export default "__VITE_ASSET__82326bd6__"